
import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import { createStore } from 'vuex';

import App from './App.vue'
import LoginPage from './LoginPage.vue'
import LoginInvalid from './LoginInvalid.vue'
import LoginLocked from './LoginLocked.vue'
import ProjectPage from './ProjectPage.vue'
import KeysPanel from './components/KeysPanel.vue'
import SingleKeyPanel from './components/SingleKeyPanel.vue'
import ConfigPage from './ConfigPage.vue'
import NotFound from './NotFound.vue'
import './assets/main.css'
import axios from 'axios';
import mitt from 'mitt';

const emitter = mitt();

const router = createRouter({
    history: createWebHistory("/"),
    routes: [
      { path: '/', component: LoginPage },
      { path: '/invalid', component: LoginInvalid },
      { path: '/locked', component: LoginLocked },
      { path: '/projects',
        meta: { requiresAuth: true },
        component: ProjectPage, children: [
          { path: ':prjnum', component: KeysPanel, props: true },
          { path: ':prjnum/keys/:keynum', component: SingleKeyPanel, props: true },
      ]},
      { path: '/projects/:prjnum/keys/:keynum/conf/:conf', component: ConfigPage, props: true },
      { path: '/:pathMatch(.*)', component: NotFound }
    ]
});

const store = createStore({
  state: {
    projectData: [],
    keyLimits: [],
    keyData: [],
  },
  mutations: {
    updateProjectData(state, projectData){
      state.projectData = projectData;
    },
    updateKeyLimits(state, keyLimits){
      state.keyLimits = keyLimits;
    }
  },
  actions: {
    getProjectData() {
      axios.get('/api/v1/project')
      .then((response) => {
        store.commit('updateProjectData', response.data.projects);
      })
      .catch((error) => {
        console.log("Error fetching project data");
        if (error.response.status == 401) {
          console.log("Get project list unauthorized, redirecting to front page");
          window.location.replace("/");
        }
      });
    },
    getKeyLimits() {
      axios.get('/api/v1/api_limits')
      .then((response) => {
        store.commit('updateKeyLimits', response.data);
      })
      .catch((error) => {
        if (error.response.status == 401) {
        console.log("Error fetching key limits");
      }
      });
    }
  }
})

const app = createApp(App);
app.use(router);
app.use(store);
app.config.globalProperties.emitter = emitter;

//global directive used in HeaderBar, CustomSelect, some alerts
app.directive('click-outside', {
  beforeMount(el, binding) {
    el.clickOutsideEvent = (event) => { // check that click was outside el and its children
      if (el === !event.target || !el.contains(event.target))  binding.value();
    };
    document.addEventListener("click", el.clickOutsideEvent);
  },
  unmounted(el) {
    document.removeEventListener("click", el.clickOutsideEvent);
  },
});

app.mount('#app');
